// Transporte básico de métricas (Fase 0): cola en memoria + sendBeacon en
// batch. El endpoint de ingesta llega con el dashboard de deflección (Fase 2);
// hasta entonces los eventos solo se loguean en dev.
import { getStableSessionId } from "../state/persistence.js";

const TRACK_ENDPOINT = import.meta.env.VITE_TRACK_ENDPOINT || null;
const FLUSH_INTERVAL_MS = 10_000;
const queue = [];

export function track(event, data = {}) {
  const entry = {
    event,
    ...data,
    sessionId: getStableSessionId(),
    ts: Date.now()
  };
  if (import.meta.env.DEV) {
    console.debug("[track]", entry);
  }
  if (!TRACK_ENDPOINT) return;
  queue.push(entry);
}

function flush() {
  if (!TRACK_ENDPOINT || queue.length === 0) return;
  const batch = queue.splice(0, queue.length);
  try {
    navigator.sendBeacon(TRACK_ENDPOINT, JSON.stringify(batch));
  } catch {
    // best-effort: las métricas nunca rompen la app
  }
}

if (typeof window !== "undefined" && TRACK_ENDPOINT) {
  setInterval(flush, FLUSH_INTERVAL_MS);
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
